"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _atoms = require("../../../atoms");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Container = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "NoOptionFound__Container"
})(["display:flex;flex-direction:column;justify-content:center;padding-top:", ";"], function (_ref) {
  var spacing = _ref.theme.spacing;
  return spacing(2);
});

var StyledBodyText = /*#__PURE__*/(0, _styledComponents["default"])(_core.Typography).withConfig({
  displayName: "NoOptionFound__StyledBodyText"
})(["margin-bottom:", ";"], function (_ref2) {
  var spacing = _ref2.theme.spacing;
  return spacing(1);
});

var ButtonContainer = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "NoOptionFound__ButtonContainer"
})(["", " text-align:center;"], function (_ref3) {
  var _ref3$theme = _ref3.theme,
      palette = _ref3$theme.palette,
      spacing = _ref3$theme.spacing;
  return (0, _styledComponents.css)(["padding-top:", ";padding-bottom:", ";background-color:", ";"], spacing(2), spacing(2), palette.grey[200]);
});

var NoOptionFound = function NoOptionFound(_ref4) {
  var headerLabel = _ref4.headerLabel,
      subHeaderLabel = _ref4.subHeaderLabel,
      onButtonClick = _ref4.onButtonClick,
      buttonLabel = _ref4.buttonLabel,
      withButton = _ref4.withButton;
  return _react["default"].createElement(Container, null, _react["default"].createElement(_core.Typography, {
    variant: "h2",
    color: "error"
  }, headerLabel), _react["default"].createElement(StyledBodyText, {
    variant: "body1"
  }, subHeaderLabel), withButton && _react["default"].createElement(ButtonContainer, null, _react["default"].createElement(_atoms.Button, {
    onClick: onButtonClick
  }, buttonLabel)));
};

NoOptionFound.propTypes = {
  headerLabel: _propTypes["default"].string.isRequired,
  subHeaderLabel: _propTypes["default"].string.isRequired,
  buttonLabel: _propTypes["default"].string,
  onButtonClick: _propTypes["default"].func,
  withButton: _propTypes["default"].bool
};
var _default = NoOptionFound;
exports["default"] = _default;